import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["disabled", "pressed"];
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { PaginationButtonMixin } from '../../mixins/components/PaginationButtonMixin';
import { Button } from '../Button/Button';

/**
 * A button used by the `Pagination` component.
 *
 * @extends Button
 * @since 7.42.0
 */
var PaginationButton = /*#__PURE__*/styled(function (_ref) {
  var disabled = _ref.disabled,
    pressed = _ref.pressed,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Button, _extends({
    borderless: true,
    "aria-pressed": pressed ? true : undefined,
    disabled: disabled,
    tabIndex: disabled ? -1 : undefined
  }, rest));
}).withConfig({
  displayName: "PaginationButton",
  componentId: "c11n-8-111-0__sc-1i6hxyy-0"
})(["", ""], PaginationButtonMixin);
PaginationButton.displayName = 'PaginationButton';
PaginationButton.propTypes = {
  /**
   * @ignore
   */
  buttonType: PropTypes.string,
  /**
   * By default, this is rendered as an HTML button. You can change it to an anchor for example
   * by changing this to "a".
   */
  forwardedAs: PropTypes.string,
  /**
   * The label for the page button, `Page x`, `Page x, current page`,
   * `Next page`, or `Previous page`
   */
  title: PropTypes.string.isRequired,
  /**
   * Sets the [aria-pressed](https://www.w3.org/TR/wai-aria-1.1/#aria-pressed) state.
   */
  pressed: PropTypes.bool
};
PaginationButton.defaultProps = {
  buttonType: 'tertiary',
  forwardedAs: undefined,
  pressed: false
};

/** @component */
export { PaginationButton };